import { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import { ICustomPlayerPreferences } from "../../interfaces/customPlayer";
import { watchService } from "../../services/watch";
import { customPlayerService } from "../../services/customPlayer";

export interface ICustomPlayerContext {
  customPlayerPreferences: ICustomPlayerPreferences;
}

export type CustomPlayerContextProps = {
  viewerId?: string;
  children: ReactNode;
}

export const CustomPlayerContext = createContext({} as ICustomPlayerContext);

export const CustomPlayerProvider: React.FC<CustomPlayerContextProps> = ({ children, viewerId }) => {
  const [customPlayerPreferences, setCustomPlayerPreferences] = useState<ICustomPlayerPreferences>(customPlayerService.defaultPlayerPreferences);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const watchSubscription = watchService.getWatchInfo().subscribe(watchInfo => {
      customPlayerService.findCustomPlayer({
        producerId: viewerId ? viewerId : watchInfo.producerId,
        videoKey: watchInfo.videoKey,
      }).then(customPlayerResponse => {
        if (customPlayerResponse) {
          setCustomPlayerPreferences({
            ...customPlayerResponse.preferences,
            customLogotypeUrl: customPlayerResponse.logotype ?? undefined,
          });
        }
      }).catch((error) => {
        console.warn('could not find customPlayer', JSON.stringify(error));
      }).finally(() => {
        setLoading(false);
      });
    });

    return () => watchSubscription.unsubscribe();
  }, [viewerId]);

  return (
    <CustomPlayerContext.Provider value={{ customPlayerPreferences }}>
      {!loading && children}
    </CustomPlayerContext.Provider>
  )
}

export const useCustomPlayerContext = () => useContext(CustomPlayerContext);
